import PropTypes from "prop-types";
import React from "react";
import { MenuItem, DropdownButton } from "react-bootstrap";

import ThemeHelper from "../../utils/ThemeHelper";

import UserStore from "../../stores/UserStore";

export default class ThemeSetting extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = ThemeSetting.getStoreState();
		this._onChange = this._onChange.bind(this);
		this.handleThemeChange = this.handleThemeChange.bind(this);
	}

	static getStoreState()
	{
		return {
			theme: UserStore.getUserProfileSetting("theme")
		};
	}

	async handleThemeChange(themeName)
	{
		const theme = ThemeHelper.themes.find(t => t.name === themeName);
		await ThemeHelper.setTheme(theme);
	}

	_onChange()
	{
		this.setState(ThemeSetting.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const selectedThemeName = this.state.theme;
		const selectedTheme = ThemeHelper.themes.find(theme => theme.name === selectedThemeName);
		const title = (selectedTheme ? selectedTheme.displayName : selectedThemeName) || "Default";
		let enabled = this.props.enabled;

		return (
			<DropdownButton
				onSelect={this.handleThemeChange}
				title={title}
				id="themeChange"
				disabled={!enabled}
			>
				{ThemeHelper.themes.map(theme => {
					return (
						<MenuItem
							key={theme.name}
							eventKey={theme.name}
							className={theme.name === selectedThemeName ? "active" : ""}
						>
							{theme.displayName}
						</MenuItem>
					);
				})}
			</DropdownButton>
		);
	}
}

ThemeSetting.propTypes = {
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/settings/ThemeSetting.jsx